import React, { useEffect, useState } from "react";
import '../../../App.css';
import useStore from "../state-files/zustondStoreStates";
import { Button } from "@mui/material";


const useInstallPrompt = () => {
    const [prompt, setPrompt] = useState(null);

    useEffect(() => {
        const handler = (e) => {
            e.preventDefault();
            setPrompt(e);
        };
        window.addEventListener("beforeinstallprompt", handler);
        return () => window.removeEventListener("beforeinstallprompt", handler);
    }, []);

    return prompt;
};

const isIOS = () => {
    return [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
    ].includes(navigator.platform)
        // Or check user agent for newer iPads
        || (navigator.userAgent.includes("Mac") && "ontouchend" in document);
};

const InstallPWAButton = () => {

    const { greenButtonSX } = useStore(); // Use zustand store
    const promptInstall = useInstallPrompt();
    const [isIphone, setIsIphone] = useState(false);

    useEffect(() => {
        setIsIphone(isIOS());
    }, []);

    // 1. If it's Android/Chrome and prompt is ready
    if (promptInstall) {
        return (
            <Button sx={[greenButtonSX, {marginTop: 1,padding: 1}]} onClick={() => promptInstall.prompt()}>
                Install App
            </Button>
        );
    }

    // 2. If it's iOS, show instructions since we can't show a button
    if (isIphone) {
        return (
            <div style={{ padding: '10px', backgroundColor: '#e8f5e9', borderRadius: '8px' }}>
                <p>To install: tap the <strong>Share</strong> icon and then <strong>"Add to Home Screen"</strong>.</p>
            </div>
        );
    }

    // 3. Default for Desktop or already installed
    return null;
};

export default InstallPWAButton;